'use strict';

dialogService.$inject = ["$q", "$rootScope", "ngDialog", "authService"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.dialogService = dialogService;
/*@ngInject*/
function dialogService($q, $rootScope, ngDialog, authService) {
    return {
        confirm: confirm,
        selectTenant: selectTenant,
        askConfirm: askConfirm,
        unsavedChanges: unsavedChanges
    };

    function confirm(scope, title, msg) {
        var deffered = $q.defer();

        var dlgScope = scope.$new(true);
        dlgScope.title = title;
        dlgScope.msg = msg;

        ngDialog.open({
            template: require('../templates/confirm.html'),
            className: 'ngdialog ngdialog-theme-default',
            plain: true,
            showClose: true,
            scope: dlgScope,
            disableAnimation: true
        }).closePromise.then(function (result) {
            if (result.value === 1) {
                deffered.resolve();
            } else {
                deffered.reject();
            }
        });

        return deffered.promise;
    }

    function selectTenant() {
        var deffered = $q.defer();
        var dlgScope = $rootScope.$new(true);
        dlgScope.tenants = authService.customUserInfo.tenants;
        dlgScope.activeTenant = dlgScope.tenants.find(function (t) {
            return !!t.secondaryAppUserKey && t.secondaryAppUserKey === authService._user.profile.SAUK || !!t.id && t.id === parseInt(authService._user.profile.BuyerID, 10);
        });

        ngDialog.open({
            template: require('../templates/select-tenant.html'),
            className: 'ngdialog ngdialog-theme-default',
            plain: true,
            showClose: true,
            scope: dlgScope,
            disableAnimation: true,
            controller: ["$scope", "common", function controller($scope, common) {
                'ngInject';

                $scope.select = function (tenant) {
                    common.log.debug('you selected tenant ' + tenant.secondaryAppUserKey);
                    $scope.closeThisDialog({ closingState: 1, tenant: tenant });
                };
            }]
        }).closePromise.then(function (result) {
            if (result.value && result.value.closingState === 1 && result.value.tenant) {
                deffered.resolve(result.value.tenant);
            } else {
                deffered.reject();
            }
        });

        return deffered.promise;
    }

    function askConfirm(title, message) {
        return ngDialog.openConfirm({
            template: '<fb-confirm-dialog message="' + message + '" message-title="' + title + '" on-cancel="closeThisDialog(\'cancel\')" on-confirm="confirm()" on-reject="closeThisDialog(\'reject\')"></fb-confirm-dialog>',
            plain: true // plain html template no url
        });
    }

    function unsavedChanges() {
        return ngDialog.openConfirm({
            template: '<fb-unsaved-changes-dialog on-discard=\"confirm()\" on-cancel=\"closeThisDialog()\"></fb-unsaved-changes-dialog>',
            plain: true // plain html template no url
        });
    }
}


//////////////////
// WEBPACK FOOTER
// ./common/services/dialogService.js
// module id = 809
// module chunks = 0